import { createStyles, makeStyles, Theme } from "@material-ui/core";

export const globalStyles = makeStyles((theme: Theme) =>
    createStyles({
        box: {
            marginTop: theme.spacing(1), 
            marginBottom: theme.spacing(1)
        },
        boldLabel: {
            marginTop: "1rem",
            fontWeight: 450  // Aggiunto per dettagli familiare
        },
        bottomLabel: {
            marginTop: '0.5rem',
        },
        bottomControlLabel: {  // Ha lo space sia a destra che a sinistra e non si allinea al bottom per il margine sotto
            verticalAlign: 'bottom',
            margin: theme.spacing(1),
            minWidth: 150,
        },
        // bottomControlLabelPersona: {   // avendo solo il margin sinistro si allinea davvero al bottom
        //     verticalAlign: 'bottom',
        //     marginLeft: theme.spacing(1),
        //     minWidth: 150,
        // },
        bottomControlLabelNoSpace: {
            verticalAlign: 'bottom',
            minWidth: 150,
        },
        // checkBoxControlLabel: {
        //     verticalAlign: 'bottom',
        //     marginLeft: theme.spacing(1),
        // },
        defaultText: {
            padding: theme.spacing(2),
            wordWrap: "break-word",
            fontSize: 13
        },
        diCui: {
            margin: theme.spacing(1),
        },
        grid: {
            maxHeight: "2.5rem",
            margin: "0.5rem 0"
        },
        formControl: {
            margin: theme.spacing(1),
            background: '#d5d4d9a8', // 98c  9a8 9e0  crescendo di meno opacità
            borderRadius: '7px'
        },
        formControlCCIAA: {
            background: '#d5d4d9a8', // 98c  9a8 9e0
            borderRadius: '7px'
        },
        formControlReadOnly: {
            margin: theme.spacing(1),
        },
        fullWidthPaper: {
            padding: theme.spacing(2),
            marginTop: theme.spacing(2),
            width: "100%"
        },
        inline: {
            textAlign: "center"
        },
        label: {
            marginTop: "1rem"
        },
        longTextField: {
            marginLeft: theme.spacing(1),
            marginRight: theme.spacing(1),
            width: 300,
            background: '#d5d4d9a8',
            borderRadius: '7px'
        },
        longTextFieldReadOnly: {
            marginLeft: theme.spacing(1),
            marginRight: theme.spacing(1),
            width: 300,
        },
        mainPaper: {
            padding: theme.spacing(2),
            marginTop: theme.spacing(2),
            width: "70%",
            minWidth: "30rem",
        },
        // mainPaperHome: {
        //     padding: theme.spacing(2),
        //     width: "70%",
        //     minWidth: "30rem",
        //     height: '100%'
        // },
        root: {
            flexGrow: 1,
        },
        rootModel: {
            padding: theme.spacing(2),
            display: 'flex',
            flexDirection: 'column',
        },        
        selectIForf: {
            width: "10rem",
        },
        select: {
            width: 200,
        },
        selectLong: {
            width: 300
        },
        // selectLong: {
        //     width: "13rem",
        // },
        tableContainer: {
            width: "100%",
            marginTop: theme.spacing(3),
            overflowX: "auto",
        },
            tableHeaderFixed: {
            minWidth: '140px'
        },
        textField: {
            marginLeft: theme.spacing(1),
            marginRight: theme.spacing(1),
            width: 200,
            background: '#d5d4d9a8',
            borderRadius: '7px'
        },
        textFieldConfronto: {
            // marginLeft: theme.spacing(1),
            marginRight: theme.spacing(1),
            width: 200,
            background: '#d5d4d9a8',
            borderRadius: '7px'
        },
        textFieldConfrontoReadOnly: {
            // marginLeft: theme.spacing(1),
            marginRight: theme.spacing(1),
            width: 200,
        },
        textFieldReadOnly: {
            marginLeft: theme.spacing(1),
            marginRight: theme.spacing(1),
            width: 200,
        },
    }),
);

export const numberFieldWidth: string = "8rem";